import Backbone from 'backbone'
import _ from 'lodash'
import template from './setting-view.hbs'
import SettingsHelper from './settings-helper'
const { getSettingPlotTypeLabel, getSettingSubText } = SettingsHelper

/**
 * Button display for a single chart "other" setting. The content rendered in the
 * button depends on the type of setting passed in
 */
const SettingView = Backbone.View.extend({
	className: 'setting-view button button-default',

	tagName: 'li',

	events: {
		'click': 'onClick'
	},

	/**
	 * @param {Object} [options.setting]
	 * @param {Object} [options.model]
	 */
	initialize: function(options) {
		this.setting = options.setting
		this.model = options.model

		let settingType = _.get(this.setting, 'settingType')
		settingType && this.$el.addClass(settingType)
	},

	render: function() {
		const options = _.extend({
			label: getSettingPlotTypeLabel(_.extend({
				plotType: this.model.get('plotType')
			}, this.setting)),
			subtext: getSettingSubText(this.setting, this.model)
		}, this.setting)

		this.$el.empty().append(template(options))
		return this
	},
	onClick: function() {
		// listening to a click on this element doesn't seem to work without this
		this.trigger('setting-editor')
	}
})

export default SettingView
SettingView.__filename__ = 'charts/edit/setting-view.js'
